import { User } from "@auth0/auth0-spa-js";
import { Authorization } from "./Authorization";

export interface MekUser extends User {
    /**
     * @deprecated Check for other properties, e.g. {@link devNumber}.
     */
    "https://login.ciam.com/identity_v2": MekIdentity;

    devNumber?: string;
    keycloakRoles?: string[];
    fromKeycloak: boolean;
    language?: string;
    market?: string;
}

/** Identities of the user in MyEnergyKey. */
export interface MekIdentity {
    /** Identifier of the user in MyEnergyKey. */
    identityId: string;
    /** Identifiers of the user in the various business systems. */
    businessSystemReferences: Array<unknown>;
    [others: string]: unknown;
}

export interface CrmUser {
    devNumber: string;
    companyName: string;
    companyDevNumber: string;
    email: string;
    firstname: string;
    phoneNumber: string;
    role: Role;
    salutation: Salutation;
    surname: string;
    primaryContact: boolean;
    contactPerson: boolean;
    market?: string;
    companyAddress: CompanyAddress;
}

export interface CockpitUser {
    mekUser?: MekUser;
    crmUser: CrmUser;
}

export enum Salutation {
    None = 0,
    Mr = 1,
    Mrs = 2,
    Family = 3,
    Company = 4,
    Diverse = 5,
}

export enum Role {
    Installer = "INSTALLER",
    EndCustomer = "ENDCUSTOMER",
    Unknown = "UNKNOWN",
}

export enum KeycloakRole {
    Technical_Service = "Technical_Service",
    Installer = "Installer",
    Customer_Support = "Customer_Support",
    Sales = "Sales",
    Stakeholder = "Stakeholder",
    ExternalServiceProvider = "ExternalServiceProvider"
}

type CompanyAddress = {
    street?: string;
    houseNumber?: string;
    city?: string;
    timezone?: string;
    postcode?: string;
    countryCode?: string;
};

export const getRoleByString = (role: string): KeycloakRole | undefined => {
    return KeycloakRole[role as keyof typeof KeycloakRole];
};

export interface ModuleApi extends Authorization {
    sendAccessTokenToIFrame(iframe: HTMLIFrameElement, host: string): Promise<void>;
    logoutInIFrame(iframe: HTMLIFrameElement, host: string): void;
}
